import { AlertTriangle } from "lucide-react";
import { toast } from "react-toastify";

// This hook provides the logic and the component together
const useWarningModal = () => {
  const showWarning = (text) => {
    // Use the toast component for a less intrusive notification
    toast.warn(text || "Please make a selection before proceeding.", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      icon: <AlertTriangle size={20} />,
    });
  };

  return showWarning;
};

export default useWarningModal;
